<script>
import { asyncAngularInvoke } from "/vodalys/vvuejs";

export default {
  props: ["component", "handler"],
  data() {
    return {
      icon: undefined,
    };
  },
  mounted() {
    asyncAngularInvoke((vfIconsService) => {
      vfIconsService.findIcon(this.component);
    });
  },
};
</script>
<template>
  <f-toast :icon="icon" v-on="$listeners">
    {{ component.label }}
  </f-toast>
</template>